import { useState } from 'react';
import { Button, Input } from '@nazka/nazka.mapframe.components';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { sendContactEmail } from '@services/email.service';

import './contact-modal.styl';

function ContactModal({ setShowContactModal }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const [status, setStatus] = useState();

  const [emailError, setEmailError] = useState();
  const [nameError, setNameError] = useState();
  const [messageError, setMessageError] = useState();
  const [groupError, setGroupError] = useState('');

  return (
    <div className="contact-modal">
      <div
        className="contact-modal__background"
        onClick={() => setShowContactModal(false)}
      />
      <div className="contact-modal__content">
        <div className="contact-modal__content__header">
          <div className="contact-modal__content__header__title">
            <h2 className="contact-modal__content__header__title__text">
              Contactformulier
            </h2>
          </div>
          <Button
            icon={faClose}
            layout="ghost"
            hover={false}
            className="contact-modal__content__header__close"
            onClick={() => setShowContactModal(false)}
          />
        </div>
        {status !== 'done' && (
          <div className="contact-modal__content__body">
            <p className="contact-modal__content__body__text">
              <span>{'Zit je met een vraag of wil je graag met ons samenwerken? Stuur een e-mail naar '}</span>
              <a href="mailto:info@naarjobs.be">info@naarjobs.be</a>
              <span>{' of gebruik onderstaand contactformulier.'}</span>
            </p>
            <div className="contact-modal__content__body__form">
              <label className={`contact-modal__content__body__form__label${nameError ? ' contact-modal__content__body__form__label--error' : ''}`}>
                <span className="contact-modal__content__body__form__label__text">
                  Naam
                </span>
                <Input
                  className="contact-modal__content__body__form__label__input"
                  value={name}
                  onInputChange={(v) => {
                    setName(v?.target?.value);
                    setNameError(false);
                    setGroupError('');
                  }}
                  rootElProps={{ onSelect: () => setNameError(false) }}
                />
              </label>
              <label className={`contact-modal__content__body__form__label${emailError ? ' contact-modal__content__body__form__label--error' : ''}`}>
                <span className="contact-modal__content__body__form__label__text">
                  E-mailadres
                </span>
                <Input
                  className="contact-modal__content__body__form__label__input"
                  value={email}
                  onInputChange={(v) => {
                    setEmail(v?.target?.value);
                    setEmailError(false);
                    setGroupError('');
                  }}
                  rootElProps={{ onSelect: () => setEmailError(false) }}
                />
              </label>
              <label className={`contact-modal__content__body__form__label${messageError ? ' contact-modal__content__body__form__label--error' : ''}`}>
                <span className="contact-modal__content__body__form__label__text">
                  Stuur ons een bericht
                </span>
                <textarea
                  value={message}
                  onChange={(v) => {
                    setMessage(v?.target?.value);
                    setMessageError(false);
                    setGroupError('');
                  }}
                  onSelect={() => {
                    setMessageError(false);
                  }}
                  className="contact-modal__content__body__form__label__input"
                  rows="5"
                />
              </label>
              {groupError && (
                <p className="contact-modal__content__body__form__error">
                  {groupError}
                </p>
              )}
              <Button 
                className="contact-modal__content__body__form__button"
                isLoading={status === 'loading'}
                disabled={status === 'loading'}
                onClick={async () => {
                  if (!name.length) {
                    setNameError(true);
                    setGroupError('Naam is niet ingevuld.');
                    return;
                  }
                  if (!email.length) {
                    setEmailError(true);
                    setGroupError('E-mailadres is niet ingevuld.');
                    return;
                  }
                  if (!message.length) {
                    setMessageError(true);
                    setGroupError('Bericht is niet ingevuld.');
                    return;
                  }
                  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!emailPattern.test(email)) {
                    setGroupError('Ongeldig e-mailadres.');
                    return;
                  }

                  setStatus('loading');
                  try {
                    await sendContactEmail(name, email, message);
                    setStatus('done');
                  } catch (e) {
                    console.error(e);
                    setGroupError(e.message)
                    setStatus('done');
                  }
                }}
              >
                Verzenden
              </Button>
            </div>
          </div>
        )}
        {status === 'done' && (
          <div className="contact-modal__content__body">
            <p className="contact-modal__content__body__done">
              Bedankt voor je bericht! We hebben je e-mail goed ontvangen en nemen zo snel mogelijk contact met je op.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default ContactModal;